export const cafetaria = {
  seo: {
    title: "Case: Cafetaria D'n Boom | Bistroo",
    description: "Read how cafetaria D'n Boom shortened queues and increased revenue with Bistroo's online ordering system.",
  },
  hero: {
    title: "Read how Cafetaria D'n Boom grew its revenue thanks to Bistroo",
    description:
      "A typical example is the cafetaria of Henk Boom, Cafetaria Eethuis D'n Boom in Berkel-Enschot — a busy cafetaria located in the heart of a lively neighborhood.",
  },
  testimonials: {
    1: {
      text: '"Now many orders come in online, which creates more calm to work, especially during peak hours. On busy Sundays we sometimes have 8 people working, and even then we couldn\'t always keep up with the phone."',
      name: 'Henk Boom',
      job_title: 'Owner',
    },
    2: {
      text: '"Thanks to Bistroo we have more control over busy moments. Before, phone orders were sometimes missed, which could have caused revenue loss. We can clearly see this in our numbers."',
      name: 'Henk Boom',
      job_title: 'Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'Born out of frustration',
      text: "Previously, Cafetaria Eethuis D'n Boom relied on phone orders, which resulted in longer wait times and frustration for both customers and staff. We asked Henk about the challenges before using Bistroo and the solutions Bistroo provides.",
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: "During peak hours, Cafetaria Eethuis D'n Boom was flooded with orders, causing staff to become overwhelmed and customers to wait longer.",
        2: 'Customers often had to wait on hold when calling, leading to a reduced customer experience and potential revenue loss.',
        3: 'Customers often only decided what they wanted to order once they were on the phone, which increased order processing times.',
        4: 'Due to poor phone connections and language barriers, orders were sometimes misunderstood and processed incorrectly, resulting in dissatisfied customers and wasted time and resources.',
      },
    },
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: "With Bistroo, Cafetaria Eethuis D'n Boom experiences significant time savings, allowing staff to work more efficiently and reducing wait times for customers.",
      2: 'Using Bistroo creates more calm, resulting in improved efficiency and a reduction in workload pressure, especially during busy periods.',
      3: "Thanks to Bistroo, Cafetaria Eethuis D'n Boom has more control over their busy moments. Before, phone orders were sometimes missed, which could have caused revenue loss. Now most orders come in online, creating more calm to work, especially during peak hours. On busy Sundays, there are sometimes 8 people in the shop, and even then the phone couldn't always be answered. Now they can focus better on the orders coming in through Bistroo.",
      4: 'All Bistroo orders are prepaid, which reduces the risk of uncollected orders and ensures smoother handling at the counter.',
    },
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: "Overall, Henk Boom from Cafetaria Eethuis D'n Boom has had very positive experiences with implementing Bistroo. The explanation of the system was clear and easy to understand. The use of the handheld printer was experienced as efficient and contributes to smooth operations. What's even more impressive is Bistroo's direct support in case of technical issues. Thanks to the system, they are immediately notified of disruptions, even if they hadn't noticed them themselves. When the printer goes offline, Bistroo contacts them promptly and relays orders verbally if needed, ensuring operational continuity for Cafetaria Eethuis D'n Boom.",
      2: "Bistroo's online ordering solution not only gave Cafetaria Eethuis D'n Boom an effective way to tackle these challenges, but also helped transform their operations. Moreover, Bistroo always offers a 30-day trial period during which customers can use the service free of charge. If a customer is not satisfied after this period, Bistroo removes everything at no cost. In practice, however, Bistroo finds that very few customers make use of this option. In almost all cases there is a mutual intention to continue using Bistroo's online ordering solution — a testament to the value and effectiveness of the solution for cafeterias like Cafetaria Eethuis D'n Boom.",
    },
  },
}
